import script from "./VersionSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionSettingsModal.vue?vue&type=style&index=0&id=43c8d0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c8d0aa"]])

export default __exports__